"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const history_1 = require("history");
exports.browserHistory = history_1.createBrowserHistory();
//# sourceMappingURL=history.js.map